<template>
  <span class="tw-inline-flex tw-items-center tw-gap-1">
    <span
      v-if="subsidiaryName"
      class="tw-text-sf-gray-light tw-text-xs tw-leading-[1] tw-uppercase"
    >
      {{ subsidiaryName }}
    </span>
    <span class="tw-text-sf-gray tw-text-sm tw-leading-[1.4] tw-font-medium">
      {{ accountName }}
    </span>
  </span>
</template>

<script setup lang="ts">
interface Props {
  accountName: string
  subsidiaryName: string
}

const { accountName = ' ', subsidiaryName = ' ' } = defineProps<Props>()
</script>
